import api from '@/api';

import { PageRequest } from '@/core/request/PageRequest';
import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';
import { BankSlip } from './Omie.types';

const CONTROLLER_URL = `${API_BASE_URL}/matrix-omie`;

const serviceInternoOmie = {
  async listBankSlips(params?: PageRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/bank-slips`,
      params,
    )) as unknown;

    return result as PageResult<BankSlip>;
  },

  async retrieveBankSlip(companyId: number) {
    const result = (await api.getReport(
      `${CONTROLLER_URL}/bank-slips/companies/${companyId}`,
      null,
    )) as unknown;

    return result as BlobPart;
  },
};

export default serviceInternoOmie;
